export const FileType = Object.freeze({
	JPG: { extension: 'jpg' },
	JPEG: { extension: 'jpeg' },
	PNG: { extension: 'png' },
	WEBP: { extension: 'webp' },
});
